import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import "../../../css/page-auth.css";
import { useAuth } from "../../Context/store/context.js";
import { fetchadmininfo } from "../../Redux/Actions/AdmininfoAction.js";
import DocumentTitle from "../../../documentTitle.js";
import { _get, _post } from "../../../apiClient.js";
import { _showToast } from "../../../toastHelper.js";

// function to handle the refresh
export function getRootPath(url) {
  const urlParts = url.split("/");
  return `/${urlParts[1]}`;
}

export default function SsoLogin() {
  DocumentTitle("Login");
  const [searchParams] = useSearchParams();
  const { storeTokens, login, showLoader, hideLoader } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const token = searchParams.get("token");
    const contactNo = searchParams.get("contactno");

    if (token && contactNo) {
      handleLogin(token, contactNo);
    } else {
      _showToast("Please provide data for all required fields", "info");
    }
  }, [searchParams]);

  // login functionality
  const handleLogin = async (token, contactno) => {
    showLoader();
    let userId = await callLogin(token,contactno);
    if (userId > 0) await fetchUserDetails();

  };

  const callLogin = async (token, contactno) => {
    let login = {
      contactNo: contactno,
      token: token,
    };

    return await _post(`/auth/verify-token`, login, null, false)
      .then((response) => {
        storeTokens(response.accessToken, response.refreshToken);
        return response.userId;
      })
      .catch((error) => {
        hideLoader();
        _showToast("Invalid credentials", "error");
        return 0;
      });
  };

  const fetchUserDetails = async () => {
    await _get(`/app-users/details`)
      .then((response) => {
        login();
        dispatch(fetchadmininfo(response));
        hideLoader();
        navigate("/dashboard");
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
        return 0;
      });
  };

  return (
    <div className="authentication-wrapper authentication-cover authentication-bg">
      <div className="authentication-inner row">
        {/* <!-- /Left Text --> */}
        <div className="d-none d-lg-flex col-lg-8 p-0">
          <div className="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center bg1 ">
            <div className="hero-banner hero-style-2 bg-image">
              <div className="banner-gallery">
                <div
                  className="thumbnail thumbnail-1"
                  data-sal-delay="500"
                  data-sal="slide-up"
                  data-sal-duration="1000">
                  <img src="images/birthday_events.jpg" alt="" />
                </div>
                <div
                  className="thumbnail thumbnail-2"
                  data-sal-delay="500"
                  data-sal="slide-down"
                  data-sal-duration="1000">
                  <img src="/images/cake_birthday.jpg" alt="" />
                </div>
                <div
                  className="online-support"
                  data-sal-delay="600"
                  data-sal="slide-right"
                  data-sal-duration="1000">
                  <div className="inner">
                    <div className="content">
                      <span className="subtitle">INVITD</span>
                      <h4 className="title">ONLINE INVITATION MAKER</h4>
                    </div>
                  </div>
                </div>
                <ul className="shape-group">
                  <li
                    className="shape-2 scene"
                    data-sal-delay="1000"
                    data-sal="fade"
                    data-sal-duration="1000">
                    <img
                      data-depth="-2"
                      src="images/shape-12.png"
                      alt="Shape"
                    />
                  </li>
                  <li
                    className="shape-4 scene"
                    data-sal-delay="1000"
                    data-sal="fade"
                    data-sal-duration="1000">
                    <img
                      data-depth="-2"
                      src="images/shape-04.png"
                      alt="Shape"
                    />
                  </li>
                </ul>
              </div>
            </div>
            <img src="images/bg-image-1.png" alt="" className="platform-bg" />

            <div className="footer bg-footer-theme fcopyright  fs-13 text-center z-index">
              <div className="row">
                <div className="col-md-5">
                  ©{new Date().getFullYear()},{" "}
                  <a
                    href="https://ajsinnovations.in/"
                    className="text-primary"
                    target="_new">
                    AJS Innovations Pvt. Ltd.
                  </a>{" "}
                  All Rights Reserved.
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /Left Text --> */}

        {/* <!-- Login --> */}
        <div className="d-flex col-12 col-lg-4 align-items-center p-sm-4 p-3">
          <div className="w-px-400 mx-auto">
            {/* <!-- Logo --> */}
            <div className="app-brand mx-6 mb-1">
              <a href="index.html">
                <span className="app-brand-logo demo">
                  <img
                    src="images/logo.png"
                    className="img-fluid my-5 auth-illustration"
                  />
                </span>
              </a>
            </div>
            {/* <!-- /Logo --> */}
            <h3 className="mb-4 fw-bold text-center">
              ONLINE INVITATION MAKER
            </h3>

            <>
              {/* Validating credentials message */}
              <div className="text-center py-5">
                <div className="mb-4">
                  <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
                <h4 className="mb-3 fw-semibold">Validating Your Credentials</h4>
                <p className="text-muted mb-0">
                  Please wait while we securely verify your information...
                </p>
                <div className="mt-4">
                  <div className="progress" style={{ height: '4px' }}>
                    <div 
                      className="progress-bar progress-bar-striped progress-bar-animated" 
                      role="progressbar" 
                      style={{ width: '100%' }}
                      aria-valuenow="100" 
                      aria-valuemin="0" 
                      aria-valuemax="100">
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </div>
  );
}
